import { Button, Tooltip, useTheme } from '@mui/material';
import React from 'react';

interface CardTooltipButtonProps {
  id: string;
  isEligible: boolean;
  tooltipTitle: React.ReactNode;
  buttonText: string;
  handleClick: () => void;
}

const CardTooltipButton = (props: CardTooltipButtonProps) => {
  const { id, isEligible, tooltipTitle, buttonText, handleClick } = props;
  const theme = useTheme();

  return (
    <Tooltip data-testid="card-tooltip-button" title={!isEligible ? tooltipTitle : ''} placement="bottom-start">
      <span>
        <Button
          id={id}
          onClick={handleClick}
          variant="contained"
          color="primary"
          disabled={!isEligible}
          fullWidth
          sx={{
            [theme.breakpoints.up('xs')]: {
              whiteSpace: 'wrap',
            },
            [theme.breakpoints.up('sm')]: {
              whiteSpace: 'wrap',
            },
            [theme.breakpoints.up('md')]: {
              whiteSpace: 'wrap',
            },
            [theme.breakpoints.up('lg')]: {
              whiteSpace: 'nowrap',
            },
            [theme.breakpoints.up('xl')]: {
              whiteSpace: 'nowrap',
            },
          }}
        >
          {buttonText}
        </Button>
      </span>
    </Tooltip>
  );
};

export default CardTooltipButton;
